/**
 * Id elementu (kontejneru) pro renderování modálních oken.
 * Změny je nutné reflektovat ve storybooku v souboru `preview-body.html`.
 * */
export const MODAL_ROOT_ID = "modalRoot";
